import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

const HeadTags = ({ title, description, keywords, canonical, robots }) => {
  const { origin } = window.location;
  const { pathname } = window.location;
  const formattedCanonical =
    canonical && canonical.indexOf(origin) < 0
      ? `${origin}${canonical}`
      : canonical;
  const formattedTitle =
    title !== HeadTags.defaultProps.title
      ? `${title} | ${HeadTags.defaultProps.title}`
      : title;
  const canonicalUrl = canonical ? formattedCanonical : `${origin}${pathname}`;

  // clean content from API
  const cleanString = string => {
    const regex = /(<([^>]+)>)/gi;
    return string ? string.replace(regex, "") : "";
  };

  return (
    <Helmet>
      <title>{formattedTitle}</title>
      {description && (
        <meta name="description" content={cleanString(description)} />
      )}
      {keywords && <meta name="keywords" content={cleanString(keywords)} />}
      {robots && robots !== "None" && (
        <meta name="robots" content={cleanString(robots)} />
      )}
      {canonicalUrl && (
        <link rel="canonical" href={cleanString(canonicalUrl)} />
      )}
      <script type="application/ld+json">{`
        {
          "@context": "http://schema.org",
          "@type": "WebSite",
          "url": "${origin}",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "${origin}/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        }
    `}</script>
    </Helmet>
  );
};

HeadTags.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  canonical: PropTypes.string,
  robots: PropTypes.string
};
HeadTags.defaultProps = {
  title: "Healthstream Store",
  description: "",
  keywords: "",
  canonical: null,
  robots: ""
};

export default HeadTags;
